import React from 'react';
import { ScreenProps } from '../ScreenBase';
import NextButton from '../NextButton';

import styles from './yesno.module.css';

interface YesNoState {
  value?: boolean;
}

class YesNo extends React.Component<ScreenProps, YesNoState> {
  state: YesNoState = {};

  setValue = (val: boolean, text: string) => {
    const { onSubmit } = this.props;

    onSubmit({ value: val ? 1 : 0, text });
    this.setState({ value: val });
  };

  render() {
    const {
      replaceTokens,
      locked,
      data: { extended_props },
    } = this.props;
    const { yes_label, no_label } = extended_props || {};
    const { value } = this.state;

    const yesText = yes_label ? replaceTokens(yes_label) : 'Sí';
    const noText = no_label ? replaceTokens(no_label) : 'No';

    return (
      <div className={styles.container}>
        <NextButton
          visible
          disabled={locked}
          className={styles.button}
          onClick={() => this.setValue(true, yesText)}
          text={yesText}
          type={value ? 'primary' : 'ghost'}
        />
        <NextButton
          visible
          disabled={locked}
          className={styles.button}
          onClick={() => this.setValue(false, noText)}
          text={noText}
          type={value === false ? 'primary' : 'ghost'}
        />
      </div>
    );
  }
}

export default YesNo;
